"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const moment_1 = tslib_1.__importDefault(require("moment"));
const TextFieldWithImage_1 = tslib_1.__importStar(require("./TextFieldWithImage"));
const flatpickr_1 = tslib_1.__importDefault(require("flatpickr"));
const da_js_1 = require("flatpickr/dist/l10n/da.js");
// Component rendered in the user interface
// <div class="date-field" style="display:flex; flex-direction:column">
//   <label for="input-id">label-text</label>
//   <div style="display: flex; flex-direction: row">
//     <input id="input-id" type="text">
//     <src="/fmk/styles/images/calendar.svg" alt="image-description">
//   </div>
//   <small optional>hint-text</small>
//   <div class="pikaday-container"></div>
// </div>
/**
 * @deprecated Use {@link WCAGDateField} instead.
 */
class DateField extends fmko_ts_common_1.Widget {
    constructor({ label, hintText }) {
        super();
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        this.element = document.createElement("div");
        this.element.classList.add("date-field");
        this.labelElement = document.createElement("label");
        this.labelElement.textContent = label;
        const inputContainer = new TextFieldWithImage_1.default({
            imageAlt: "Tryk på ikonet for at vælge en dato",
            imagePosition: TextFieldWithImage_1.ImagePosition.AFTER,
            imageSrc: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.CALENDAR)
        });
        this.input = inputContainer.getInput();
        this.input.maxLength = 10;
        const inputId = fmko_ts_common_1.GlobalCounter.next();
        this.input.id = inputId;
        this.labelElement.htmlFor = inputId;
        this.element.appendChild(this.labelElement);
        this.element.appendChild(inputContainer.element);
        if (hintText) {
            const hintArea = document.createElement("small");
            hintArea.textContent = hintText;
            this.element.appendChild(hintArea);
        }
        flatpickr_1.default.localize(da_js_1.Danish);
        (0, flatpickr_1.default)(this.input, {
            dateFormat: "d-m-Y",
            locale: da_js_1.Danish,
            onChange: (selectedDates) => {
                const [firstDate] = selectedDates;
                if (firstDate && this.oldValue !== firstDate) {
                    this.oldValue = firstDate;
                    this.handlerManager.fireEvent(new fmko_ts_common_1.ValueChangeEvent(firstDate));
                }
            }
        });
        // new Pikaday({
        //     container: container,
        //     field: this.input,
        //     firstDay: 1,
        //     format: DateField.defaultFormat,
        //     i18n: DateField.i18n,
        //     onSelect: (date: Date) => {
        //         if (this.oldValue !== date) {
        //             this.oldValue = date;
        //             this.handlerManager.fireEvent(new ValueChangeEvent<Date>(date));
        //         }
        //     }
        // });
        this.input.addEventListener("blur", () => {
            // Handle when field is cleared
            if (!this.input.value && this.oldValue) {
                this.oldValue = null;
                this.handlerManager.fireEvent(new fmko_ts_common_1.ValueChangeEvent(this.oldValue));
            }
        });
    }
    addInputClasses(...classes) {
        this.input.classList.add(...classes);
    }
    removeInputClasses(...classes) {
        this.input.classList.remove(...classes);
    }
    getValue() {
        return this.parseDate(this.input.value);
    }
    setValue(value, fireEvents = false) {
        if (value !== this.oldValue) {
            const formatted = value ? (0, moment_1.default)(value).format(DateField.defaultFormat) : null;
            this.input.value = formatted;
            if (fireEvents) {
                fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, this.oldValue, value);
            }
        }
        this.oldValue = value;
    }
    clearValue() {
        this.setValue(null);
        this.oldValue = null;
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    setEnabled(enabled) {
        this.input.toggleAttribute("disabled", !enabled);
    }
    addOnBlurHandler(handler) {
        // Focus cannot be lost (blurred) from a div (without modifying it's contenteditable attribute,
        // or setting a manual tab-index attribute)
        this.input.addEventListener("blur", handler.bind(this));
    }
    addOnFocusHandler(handler) {
        // Focus cannot be gained (focused) from a div (without modifying it's contenteditable attribute,
        // or setting a manual tab-index attribute)
        this.input.addEventListener("focus", handler.bind(this));
    }
    getInput() {
        return this.input;
    }
    parseDate(s) {
        if (!s) {
            return undefined;
        }
        let parts = s.match(/(\d{2})-(\d{2})-(\d{4})/);
        if (parts === null) {
            return undefined;
        }
        return new Date(+parts[3], +parts[2] - 1, +parts[1]);
    }
}
DateField.defaultFormat = "DD-MM-YYYY";
exports.default = DateField;
//# sourceMappingURL=DateField.js.map